import {
    ArrowLeftOutlined,
    ArrowRightOutlined,
    PlusOutlined,
} from '@ant-design/icons';
import { Button, Divider, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ICON_DELETE, ICON_STEP_3 } from './IconStep';
import ProgressBar from './ProgressBar';
import Sticky from 'react-sticky-el';

export default function Step3(props) {
    const { t } = useTranslation(['consent', 'translation']);
    const onPreviousStep = () => {
        props.previousStep();
    };
    const onNextStep = () => {
        props.form.validateFields().then((values) => {
            console.log(values);
            props.nextStep();
        });
    };
    return (
        <div className="bg-white p-4 rounded-lg">
            <Sticky
                boundaryElement=".block_"
                stickyClassName="bg-white p-4 shadow rounded-lg z-50"
            >
                <div className="flex justify-between items-center w-full">
                    <Button
                        size="large"
                        className="!border-purple !text-purple"
                        onClick={onPreviousStep}
                    >
                        <ArrowLeftOutlined /> {t('Previous Step')}
                    </Button>
                    <Button type="primary" size="large" onClick={onNextStep}>
                        {t('Next Step')} <ArrowRightOutlined />
                    </Button>
                </div>
            </Sticky>
            <Divider />
            <div className="flex space-x-2 items-center">
                {ICON_STEP_3}
                <div>
                    <div className="text-base font-medium text-[#65707A]">
                        {t('Step')} 3 / 5
                    </div>
                    <div className="text-xl font-semibold">
                        {t('New_Step3')}
                    </div>
                </div>
            </div>
            <ProgressBar percent={60} />
            <div>
                <strong>{t('Note', { ns: 'translation' })}:</strong>
                <ul>
                    <li>
                        {t(
                            'The text in each field is displayed as an Identity value in the Dashboard Consent table'
                        )}
                    </li>
                    <li>
                        {t(
                            'A minimum of 1 field is required and a maximum of 4 fields is allowed'
                        )}
                    </li>
                </ul>
            </div>
            <Form.List name="templateDesignIdentity">
                {(fields, { add, remove }) => (
                    <>
                        {fields.map(({ key, name, ...restField }) => (
                            <div
                                key={key}
                                className="flex w-full gap-4 items-start"
                            >
                                <div className="bg-[#F4F6FC] p-4 mb-4 rounded-t-lg w-full">
                                    <Form.Item
                                        {...restField}
                                        label={t('Field name', { lang: 'TH' })}
                                        name={[name, 'labelNameTh']}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('RequiredField'),
                                            },
                                        ]}
                                    >
                                        <Input.TextArea
                                            rows={4}
                                            className="bg-white_text_input"
                                            placeholder={t('inputpl')}
                                            maxLength={255}
                                            showCount
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        label={t('Field name', { lang: 'EN' })}
                                        name={[name, 'labelNameEn']}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('RequiredField'),
                                            },
                                        ]}
                                    >
                                        <Input.TextArea
                                            rows={4}
                                            className="bg-white_text_input"
                                            placeholder={t('inputpl')}
                                            maxLength={255}
                                            showCount
                                        />
                                    </Form.Item>
                                </div>
                                {fields.length > 1 ? (
                                    <button onClick={() => remove(name)}>
                                        {ICON_DELETE}
                                    </button>
                                ) : (
                                    <div className="w-[52px]" />
                                )}
                            </div>
                        ))}
                        {fields.length < 4 && (
                            <Form.Item>
                                <Button
                                    type="link"
                                    onClick={() => add()}
                                    icon={<PlusOutlined />}
                                >
                                    <span className="underline">
                                        {t('Add field', { ns: 'translation' })}
                                    </span>
                                </Button>
                            </Form.Item>
                        )}
                    </>
                )}
            </Form.List>
        </div>
    );
}
